import React, { useState } from 'react';
import { Modal } from "antd";
import $ from 'jquery';
import SubmitACase from '../../views/submit-a-case';
import { useEffect } from 'react';

function SubmitCaseModal (props) {

    const [submitCase, setSubmitCase] = useState(false);

    const closeModal = () => {
        setSubmitCase(false);
    }
    useEffect(() => {
        if(submitCase){
             setTimeout(() => {
                $(".ant-modal-header").css('padding', '0px');
                $('.ant-modal-wrap').addClass('modal fade show');
                $('.ant-modal-content').css({ "bottom": "36px" });
            }, 100);
        }  
    }, [submitCase]);

    const OnSubmitCaseClick = () => {
        setSubmitCase(true);   
    }

    return (
        <>
            <span onClick={OnSubmitCaseClick} style={{ padding: "5px 100px 5px 0px" }}>
                {props.children}
            </span>
            {
                <Modal open={submitCase} closable={false} className="modal-dialog modal-md text-primary" maskClosable={false} destroyOnClose={true} width={550} footer={null}
                    title={
                        [
                            <div className="modal-header p-2 bg-primary text-white" key='Submit A Case'>
                                <span className="modal-title mt-1">Submit A Case</span>
                                <div> <button type="button" className="far fa-lg fa-times-circle pull-right" data-dismiss="modal" onClick={() => closeModal()}> </button> </div>
                            </div>
                        ]} bodyStyle={{ padding: '9px 0px ' }}>
                    <SubmitACase cancel={closeModal} />
                </Modal>
            }
        </>
    );
}

export default SubmitCaseModal;
